<template>
    <div class="review-sheet" style="margin:0 auto;width:1200px;margin-top:20px;margin-bottom:20px;">
    <review-opinion-result
          :form="savedOpinion"
          :id="id"
          :cid="aid"
          :base="{
            name: info.name,
            company: info.unit,
            reviewers: info.reviewers
          }"
          :zs="zs"
        />
  </div>
</template>

<script>

import {gfinfo} from "../../utils/api";
import ReviewOpinionResult from './ReviewOpinionResult.vue'

export default {
    components: {
        ReviewOpinionResult
    },
    data() {
        return {
            id: '',
            award_id:'',
            info:{name:'',unit:'',reviewers:'',date:''},
            savedOpinion:{},
            title:'',
            aid:'',
            zs:''
        };
    },
    async created() {
        let res;
        this.id = this.$route.query.id;
        this.aid = this.$route.query.aid;
        console.log('thisid',this.id);
        if (this.$route.query.id) {
            try {
                const res = await gfinfo(this.id, this.aid);
                console.log('res', res);
                this.savedOpinion = res.checked_opinions || {};
                console.log('checked_opinions', this.savedOpinion);
                this.info.name = res.gf_name || '';
                this.info.unit = res.unit || '';
                this.info.reviewers = res.ename || '';
                this.info.date = res.gf_date || '';
                this.zs = res.is_leader == 2 ? 1 : 2;
            } catch (error) {
                this.savedOpinion = {};
                this.$message.error('评审意见加载失败，请稍后重试');
            }
        }
    },
    methods: {
    },
};
</script>

<style lang="less" scoped>
.review-sheet {
  background: #fff;
  color: #303133;
  font-size: 14px;
}

/* 标题 */
.sheet-title {
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 12px;
  padding:15px 0px;
}

/* 通用表格风格（接近 Word） */
.base-table,
.review-table,
.opinion-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 16px;
}

.base-table th, .base-table td,
.review-table th, .review-table td,
.opinion-table th, .opinion-table td {
  border: 1px solid #606266;
  padding: 8px 10px;
  line-height: 20px;
  vertical-align: middle;
}

/* 基本信息 */
.base-table th {
  width: 16%;
  text-align: center;
  background: #f5f7fa;
  font-weight: 600;
}
.base-table td {
  width: 34%;
}

/* 审查表格 */
.review-table thead th {
  text-align: center;
  background: #f5f7fa;
  font-weight: 600;
}
.col-project  { width: 120px; }
.col-category { width: 150px; }
.col-standard { min-width: 240px; }
.col-content  { min-width: 300px; }

.td-project  { text-align: center; font-weight: 600; }
.td-category { white-space: normal; word-break: break-all; }
.td-standard { white-space: normal; word-break: break-all; }
.td-content  { white-space: normal; word-break: break-all; }

/* 审查人意见 */
.opinion-table th {
  width: 35%;
  background: #f5f7fa;
  font-weight: 600;
  text-align: left;
}
.opinion-table td { width: 65%; }

/* 打印优化 */
@media print {
  .review-sheet {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  .sheet-title { margin-bottom: 6mm; }
}
</style>
